export default "__VITE_ASSET__BFGMxhvE__"